// extracted by mini-css-extract-plugin
export default {"metricsWrapper":"IndependentIraTransactions_metricsWrapper__yy--0"};